export default "__VITE_ASSET__BviSDPCR__"